import './setupProcessEnv'
import React from 'react'
import ReactDOM from 'react-dom'
import { createBrowserHistory } from 'history/cjs/history'

import { Provider } from 'react-redux'

// AI Copilot widget — floating ✨ assistant, shown only while signed in
import { mountCopilot } from 'services/copilotWidget'

import store from './redux/store'

import StylesLoader from './stylesLoader'

import Localization from './localization'
import Router from './router'
import * as serviceWorker from './serviceWorker'

// middlewared
const history = createBrowserHistory()

// antd's rc-resize-observer and recharts' ResponsiveContainer both relayout from
// inside a ResizeObserver callback, so the browser defers the follow-up
// notifications and reports it on window. It is benign, so keep it out of the
// console. This cannot also stop the dev overlay: webpack-dev-server registers
// its own window listener before this bundle evaluates, and for an event whose
// target is window itself the capture flag does not reorder the two. The overlay
// is filtered by the client.overlay.runtimeErrors hook in config-overrides.js.
if (process.env.NODE_ENV === 'development') {
  const RESIZE_OBSERVER_NOISE =
    /^(ResizeObserver loop limit exceeded|ResizeObserver loop completed with undelivered notifications)/
  window.addEventListener(
    'error',
    (e) => {
      if (RESIZE_OBSERVER_NOISE.test(e.message)) {
        e.stopImmediatePropagation()
        e.preventDefault()
      }
    },
    true,
  )
}

ReactDOM.render(
  <Provider store={store}>
    <StylesLoader>
      <Localization>
        <Router history={history} />
      </Localization>
    </StylesLoader>
  </Provider>,
  document.getElementById('root'),
)

// Show the copilot bubble on a reload if the user is already signed in (no-op otherwise).
mountCopilot()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
export { store, history }
